/* eslint-disable @typescript-eslint/no-explicit-any */
// Notificaciones: copia de cada correo que manda Innobo Hub (iNotifications). Solo admin (rol 19).
// La lista viene sin HTML; al abrir una fila se pide el correo completo y se muestra en un iframe aislado
// (sandbox sin scripts), tal como le llegó al cliente.
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Input, Label, Button, Badge, Table } from 'reactstrap';
import moment from 'moment';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import Iloading from '../../components/Common/iComponents/iLoading/Iloading';
import { getNameClient } from '../../helpers/nameClient';
import { getNotifications, getNotificationFilters, getNotificationHtml } from '../../helpers/notifications_helper';

const esAdmin = () => {
  try {
    return String(JSON.parse(localStorage.getItem('authUser') || '{}').ROL_ID) === '19';
  } catch (e) {
    return false;
  }
};
const fecha = (s: any) => (s ? moment(s).format('YYYY-MM-DD HH:mm') : '');
const VACIO = { from: moment().subtract(7, 'days').format('YYYY-MM-DD'), to: moment().format('YYYY-MM-DD'), clientId: '', action: '', status: '', fallback: '', search: '' };

export const Notifications = () => {
  const admin = esAdmin();
  const [pagination, setPagination] = useState<{ sizePerPage: number; page: number }>({ sizePerPage: 50, page: 1 });
  const [borrador, setBorrador] = useState<any>(VACIO);
  const [filters, setFilters] = useState<any>(VACIO);
  const [order, setOrder] = useState("{'id' : 'DESC'}");
  const [data, setData] = useState<{ listData: any[]; CountItems: number }>({ listData: [], CountItems: 0 });
  const [opciones, setOpciones] = useState<{ clients: any[]; actions: string[] }>({ clients: [], actions: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [popUp, setPopUp] = useState(false);
  const [fila, setFila] = useState<any>(null);
  const [html, setHtml] = useState<string | null>(null);

  useEffect(() => {
    if (!admin) return;
    getNotificationFilters().then(setOpciones).catch(() => null);
  }, [admin]);

  useEffect(() => {
    if (!admin) return;
    const cargar = async () => {
      setLoading(true);
      setError('');
      try {
        setData(await getNotifications({ pagination, filters, order }));
      } catch (e: any) {
        setError(e?.message || 'Error');
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, [admin, pagination, filters, order]);

  const buscar = () => {
    setFilters({ ...borrador });
    setPagination({ ...pagination, page: 1 });
  };
  const limpiar = () => {
    setBorrador(VACIO);
    setFilters(VACIO);
    setPagination({ ...pagination, page: 1 });
  };
  const cambiar = (k: string) => (e: any) => setBorrador({ ...borrador, [k]: e.target.value });

  const handleTableSort = (type: any, { sortField, sortOrder }: any) => {
    if (!sortField || !sortOrder) return;
    setOrder(`{'${sortField}' : '${String(sortOrder).toUpperCase()}'}`);
  };

  const abrir = async (row: any) => {
    setFila(row);
    setHtml(null);
    try {
      setHtml(await getNotificationHtml(row.id));
    } catch (e) {
      setHtml('');
    }
  };

  const columns = [
    { text: 'Date', visibleInTable: true, dataField: 'createdAt', formatter: (c: any, r: any) => <>{fecha(r.sentAt || r.createdAt)}</> },
    { text: 'Client', visibleInTable: true, dataField: 'clientName', formatter: (c: any, r: any) => <>{r.clientName ? `${r.clientId} - ${r.clientName}` : r.clientId}</> },
    { text: 'Type', visibleInTable: true, dataField: 'action' },
    {
      text: 'Status',
      visibleInTable: true,
      dataField: 'status',
      formatter: (c: any, r: any) => <Badge color={r.status === 'SENT' ? 'success' : 'danger'}>{r.status}</Badge>,
    },
    { text: 'Subject', visibleInTable: true, dataField: 'subject' },
    { text: 'To', visibleInTable: true, dataField: 'toAddresses' },
    { text: 'From', visibleInTable: true, dataField: 'fromAddress' },
    { text: 'Via', visibleInTable: true, dataField: 'via' },
    {
      text: 'Fallback',
      visibleInTable: true,
      dataField: 'fallback',
      formatter: (c: any, r: any) => (r.fallback ? <Badge color="warning">Innobo</Badge> : <></>),
    },
  ];

  if (!admin) {
    return (
      <div className="page-content">
        <Container fluid>
          <p className="text-center mt-5">You don&apos;t have access to this page.</p>
        </Container>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageTitle>
          <title>Notifications | {getNameClient()}</title>
        </PageTitle>
        <Container fluid>
          <div className="container-sm">
            <Iloading loading={loading} />
          </div>
          <Row className="align-items-end mb-3">
            <Col md={2}>
              <Label className="mb-1">From</Label>
              <Input type="date" value={borrador.from} onChange={cambiar('from')} />
            </Col>
            <Col md={2}>
              <Label className="mb-1">To</Label>
              <Input type="date" value={borrador.to} onChange={cambiar('to')} />
            </Col>
            <Col md={2}>
              <Label className="mb-1">Client</Label>
              <Input type="select" value={borrador.clientId} onChange={cambiar('clientId')}>
                <option value="">All</option>
                {opciones.clients.map((c: any) => (
                  <option key={c.id} value={c.id}>{`${c.id} - ${c.name}`}</option>
                ))}
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mb-1">Type</Label>
              <Input type="select" value={borrador.action} onChange={cambiar('action')}>
                <option value="">All</option>
                {opciones.actions.map((a: string) => (
                  <option key={a} value={a}>{a}</option>
                ))}
              </Input>
            </Col>
            <Col md={1}>
              <Label className="mb-1">Status</Label>
              <Input type="select" value={borrador.status} onChange={cambiar('status')}>
                <option value="">All</option>
                <option value="SENT">SENT</option>
                <option value="ERROR">ERROR</option>
              </Input>
            </Col>
            <Col md={1}>
              <Label className="mb-1">Fallback</Label>
              <Input type="select" value={borrador.fallback} onChange={cambiar('fallback')}>
                <option value="">All</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mb-1">Search</Label>
              <Input
                type="text"
                placeholder="Subject, recipient, sender..."
                value={borrador.search}
                onChange={cambiar('search')}
                onKeyDown={(e: any) => e.key === 'Enter' && buscar()}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col className="d-flex justify-content-end">
              <Button className="btn-base me-2" onClick={buscar}>
                <i className="bx bx-search me-1" /> Search
              </Button>
              <Button color="light" onClick={limpiar}>
                Clear
              </Button>
            </Col>
          </Row>
          {error ? <p className="text-danger">{error}</p> : null}
          <Row>
            <ITable
              remote={true}
              CountItems={data.CountItems}
              handlerPaginationState={(s: any) => setPagination(s)}
              data={data.listData}
              fields={columns}
              tableColumns={columns}
              headerColorT="bg-primary text-white"
              actionOnRowClick={abrir}
              handlePopUpState={() => setPopUp(!popUp)}
              groupName="NotificationsList"
              handleTableSort={handleTableSort}
            />
          </Row>
        </Container>
      </div>
      <IPopUp
        stateAdd={popUp}
        switchStateAdd={setPopUp}
        modalTitleAdd={fila ? `${fila.id} · ${fila.subject || ''}` : ''}
        modaleTitleUpdate={'Notification'}
        icon="envelope"
        colorHeaderPop={'#101340'}
        width="85vw"
        height="85vh"
      >
        {fila ? (
          <div className="p-3">
            <Table size="sm" bordered className="mb-3">
              <tbody>
                <tr><th style={{ width: 140 }}>Client</th><td>{fila.clientName ? `${fila.clientId} - ${fila.clientName}` : fila.clientId}</td></tr>
                <tr><th>Type</th><td>{fila.action}</td></tr>
                <tr><th>Status</th><td><Badge color={fila.status === 'SENT' ? 'success' : 'danger'}>{fila.status}</Badge></td></tr>
                <tr><th>Sent</th><td>{fecha(fila.sentAt || fila.createdAt)}</td></tr>
                <tr><th>From</th><td>{fila.fromAddress} {fila.via ? `(${fila.via})` : ''} {fila.fallback ? <Badge color="warning">Innobo fallback</Badge> : null}</td></tr>
                <tr><th>To</th><td>{fila.toAddresses}</td></tr>
                <tr><th>Shipment GUID</th><td>{fila.number}</td></tr>
                {fila.error ? <tr><th>Error</th><td className="text-danger" style={{ whiteSpace: 'pre-wrap' }}>{fila.error}</td></tr> : null}
              </tbody>
            </Table>
            {html === null ? (
              <p>Loading email...</p>
            ) : html ? (
              <iframe
                title="email"
                sandbox="allow-popups allow-popups-to-escape-sandbox"
                srcDoc={html}
                style={{ width: '100%', height: '60vh', border: '1px solid #eef0f4', borderRadius: 8, background: '#fff' }}
              />
            ) : (
              <p>This notification has no saved content.</p>
            )}
          </div>
        ) : null}
      </IPopUp>
    </React.Fragment>
  );
};

export default Notifications;
